<template>
  <div class="view">
    <v-container fluid>
      <v-row>
        <v-col class="col-2">
          <router-link to="/report">กลับหน้ารายงาน</router-link>
        </v-col>
        <!--<v-col class="text-right">-->
        <!--<DatePickerMonth :dateFrom="dateFrom" :dateTo="dateTo" :onApply="onChangeDate"></DatePickerMonth>-->
        <!--</v-col>-->
        <v-col @click="openSales()" style="" v-if="[
          UserConst.ROLE_ADMIN,
          UserConst.ROLE_CEO,
          UserConst.ROLE_DIRECTOR,
          UserConst.ROLE_MANAGER,
          UserConst.ROLE_ACCOUNT
          ].includes($store.state.$user.role)">
          <span style="zoom: 0.5;">
          <Avatar v-for="sale in sales" :active="true" :user="sale" v-bind:key="sale.id"></Avatar>
          </span>
          <v-btn class="ml-2">เลือกเซล</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <!--<v-col class="col-md-8">-->
        <!--<v-simple-table class="overview-list" dense>-->
        <!--<template v-slot:default>-->
        <!--<tbody>-->
        <!--<tr>-->
        <!--<td>เดือน</td>-->
        <!--<td class="text-right">จำนวน</td>-->
        <!--<td class="text-right">ยอดขาย</td>-->
        <!--<td class="text-right">ยอดหาร</td>-->
        <!--<td class="text-right">%</td>-->
        <!--<td class="text-right">ค่าคอมฯ</td>-->
        <!--<td class="text-right">คอมฯนอก</td>-->
        <!--</tr>-->
        <!--<tr v-for="(item, index)  in summary_so" :key="index">-->
        <!--<td>{{ $helper.parseMonth(item.label) }}</td>-->
        <!--<td class="text-right" :class="item.css">{{ $helper.number_format(item.total_count,0) }} ใบ</td>-->
        <!--<td class="text-right" :class="item.css">{{ $helper.number_format(item.total_so,0) }}</td>-->
        <!--<td class="text-right" :class="item.css">{{ $helper.number_format(item.total_share,0) }}</td>-->
        <!--<td class="text-right" :class="item.css">{{ $helper.number_format(item.com_percent,1) }} %</td>-->
        <!--<td class="text-right" :class="item.css">{{ $helper.number_format(item.total_amount,0) }}</td>-->
        <!--<td class="text-right" :class="item.css">{{ $helper.number_format(item.total_external_discount,0) }}-->
        <!--</td>-->


        <!--</tr>-->
        <!--</tbody>-->
        <!--</template>-->
        <!--</v-simple-table>-->

        <!--</v-col>-->
        <!--<v-col class="text-right">-->
        <!--<div class="summary">-->
        <!--<span v-if="summary.commission_amount">-->
        <!--% ค่าคอมฯ {{$helper.number_format(summary.commission_amount,2,2)}} บาท<br/>-->
        <!--</span>-->
        <!--<span v-if="summary.total_external_discount">-->
        <!--ค่าคอมฯนอก {{$helper.number_format(summary.total_external_discount,2,2)}} บาท<br/>-->
        <!--</span>-->
        <!--</div>-->
        <!--</v-col>-->
      </v-row>

      <v-data-table
          v-if="slips && Array.isArray(slips)"
          :headers="headers"
          :items="slips"
          :options.sync="options"
          :server-items-length="totalRecords"
          :loading="loading"
          @click:row="viewSlip"
          class="elevation-1 tr-clickable"
      >

        <template v-slot:item.paid_at="{ item }">
          {{ $helper.date_format_short(item.paid_at)}}
        </template>
        <template v-slot:item.total_internal_amount="{ item }">
          {{ $helper.number_format(item.total_internal_amount,2,2) }}
        </template>
        <template v-slot:item.total_external_amount="{ item }">
          {{ $helper.number_format(item.total_external_amount,2,2) }}
        </template>

      </v-data-table>

    </v-container>
  </div>
</template>
<style scoped>

  .view {
    font-size: 18px;
  }

  .right-box {
    height: 30vh;
  }

  .right-col {
    padding-top: 0;
    padding-bottom: 0;
  }

  .right-container {
    padding: 0;
  }

  .bold {
    font-weight: bold;
  }

  .overview-list {
    background: transparent;
  }
</style>
<script lang="ts">

  import Avatar from '@/components/User/Avatar.vue'
  import {Component, Vue, Watch} from 'vue-property-decorator'
  import LoadingDummy from '../../components/LoadingDummy.vue'
  import DatePickerMonth from '../../components/Util/DatePickerMonth.vue'
  import {DataArray} from '../../models/Response'
  import {Slip, SlipConst} from '../../models/Slip'
  import {User, UserConst} from '../../models/User'

  import Helper from '../../services/Helper.js'

  @Component({
    components: {DatePickerMonth, LoadingDummy, Avatar},
  })
  export default class ViewReportSlip extends Vue {
    search = ''

    UserConst = UserConst

    SlipConst = SlipConst
    slips: Slip[] = []

    dateFrom: string = '1970-01-01'
    dateTo: string = '1970-01-01'

    selectedSlip: Slip | null = null
    summary = {
      commission_amount: 0,
      total_external_discount: 0,
    }

    summary_so = [
      {label: 'Loading', total_count: 0, total_so: 0, total_share: 0, total_amount: 0, com_percent: 0},
    ]

    totalRecords = 0

    loading = true
    options = {
      groupBy: [],
      groupDesc: [],
      itemsPerPage: 10,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: ['paid_at'],
      sortDesc: [0],
    }
    // options = {
    //   page: 1,
    //   itemsPerPage: 10,
    //   sortBy: 'order',
    //   sortDesc: true,
    // }
    headers = [
      // {text: 'order', value: 'code'},
      {text: 'code', value: 'code'},
      // {text: 'จ่าย', value: 'receipt_date'},
      {text: 'วันที่', value: 'paid_at'},
      {text: 'แผนก', value: 'user.department'},
      {text: 'รหัส', value: 'user.employee_code'},
      {text: 'ชื่อ', value: 'user.name'},
      // {text: 'ใบเสร็จ', value: 'receipt_code'},
      // {text: 'ลูกค้า', value: 'customer'},
      // {text: 'จังหวัด', value: 'customer.province'},
      // {text: 'ยอด ex.vat', value: 'total_gross', align: 'end'},
      {text: 'ค่าคอม', value: 'total_internal_amount', align: 'end'},
      {text: 'ค่าคอมนอก', value: 'total_external_amount', align: 'end'},
    ]

    @Watch('options')
    onOptionChanged() {
      this.reload()
    }


    mounted() {
      // console.log('this.dateFrom',this.dateFrom);
      let tzoffset = (new Date()).getTimezoneOffset() * 60000

      if (this.$route.params.month) {
        if (this.$route.params.month == 'previous') {
          var tmpDateFrom = new Date(Date.now())
          tmpDateFrom.setDate(0)
          this.dateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
          tmpDateFrom.setDate(1)
          this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
        }
      } else {
        let tmpDateFrom = new Date(Date.now())
        tmpDateFrom.setDate(1)
        const strDateFrom = (new Date(tmpDateFrom.getTime() - tzoffset))
        this.dateFrom = strDateFrom.toISOString().substr(0, 10)

        let startOfMonth = (new Date(Date.now() - tzoffset))
        this.dateTo = startOfMonth.toISOString().substr(0, 10)
      }

    }

    onChangeDate(dateFrom, dateTo) {
      this.dateFrom = dateFrom
      this.dateTo = dateTo
      this.options.page = 1
      this.reload()
    }

    reload() {
      let url = Helper.setting.slip.getListAPI

      const {sortBy, sortDesc, page, itemsPerPage} = this.options

      let option = ''
      option += `&summary=1`

      if (sortDesc.length > 0) {
        option += `&sortDesc=${sortDesc[0]}`
      }


      // option += `&status=` + [
      //   SlipConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO,
      //   SlipConst.STATUS_DO_CONFIRMED_WAIT_STOCK,
      //   SlipConst.STATUS_ON_DELIVERY,
      //   SlipConst.STATUS_INVOICED,
      //   SlipConst.STATUS_PAID,
      // ].join()

      if (this.dateFrom && this.dateTo) {
        option += `&rc_from_date=${this.dateFrom}&rc_to_date=${this.dateTo}`
      }

      if (this.sales.length > 0) {
        // console.log(this.sales.map(sale => sale.employee_code))
        option += `&sales=${this.sales.map(sale => sale.employee_code).join(',')}`
      }
      //
      if (page) {
        option += `&page=${page}`
      }
      if (itemsPerPage) {
        option += `&page_size=${itemsPerPage}`
      }


      if (option != '') {
        url = url + '?' + option.substr(1)
      }


      console.log('getUrlFilter', url)

      Helper.get(url)
        .then<{ data: DataArray }>(({data}) => {

          this.slips = data.data
          if (data.meta.total) {
            this.totalRecords = data.meta.total
          }

          if (data.summary) {
            this.summary = data.summary
            if (data.summary.summary_so) {
              this.summary_so = data.summary.summary_so
            }
          }
          // console.log("slips",this.slips);

          this.loading = false
        }).catch(() => {
      })
    }

    viewSlip(item, debug) {
      const option = {slip: item, slips: this.slips, debug: debug}
      console.log('option', option)
      this.$root.$emit('openSlip', option)
    }

    sales: User[] = []

    private openSales() {
      // debugger
      this.$root.$emit('openSales', {
        sales: this.sales, onApply: async (sales) => {
          this.sales = []
          for (let i in sales) {
            if (!sales.hasOwnProperty(i)) continue
            const user_code = sales[i].user_code
            if (!this.$store.state.users.code_map.hasOwnProperty(user_code)) continue
            const sale = this.$store.state.users.code_map[user_code]
            this.sales.push(sale)
          }


          // console.log(sales)
          this.reload()
        },
      })
    }
  }
</script>
